<template>
  <page-header title="Нагрузочное тестирование" icon="bi-minecart-loaded"/>
  <f-loader ref="loader2"/>
  <f-loader ref="loader">
    <div class="d-flex gap-2 align-items-end mb-2">
      <fl-input v-model="chatServer" label="URL чатсервера (включая проект)" class="flex-grow-1"/>
      <fl-input v-model.number="nMessages" label="Кол-во исход.сообщений"/>
      <fl-input v-model.number="nConnections" label="Кол-во соединений"/>
      <fl-input v-model.number="nProcesses" label="Кол-во процессов"/>
      <button @click="onStart" class="btn btn-sm btn-primary mb-1">Запустить</button>
    </div>
    <simple-table
        title="Процессы"
        :items="status"
        :format="[
          ['pid', 'PID'],
          ['chat_server', 'Чатсервер'],
          ['n_messages', 'Исх.сообщ.'],
          ['n_connections', 'Соед.'],
          ['progress', 'Прогресс', i=>Math.round(i.progress) + '%'],
          ['msg_rate', 'Сообщ/с', i=>Math.round(i.msg_rate*100)/100],
          ['tasks_succeeded', 'Успешных'],
          ['tasks_failed', 'Неуспешных'],
          ['success_rate', '%Успешных', i=>i.tasks_succeeded+i.tasks_failed!=i.n_connections?'?':Math.round(100*i.tasks_succeeded/(i.tasks_succeeded+i.tasks_failed))+'%'],
          ['running', 'Завершен', i=>i.running?'Нет':'Да'],
        ]"
        :select="i=>i.pid==selectedPid"
        :row-class="i=>i.running?'fw-bold':(i.tasks_succeeded==i.n_connections?null:'text-danger')"
        :page-size="10"
        @click-item="onClickProcess"
        class="mb-3"
    />
    <div v-if="process" class="d-flex flex-column p-2 border border-secondary-subtle rounded shadow-sm gap-2">
      <div class="d-flex gap-2 align-items-center">
        <p class="h4 text-nowrap position-relative px-2 py-1 bg-light rounded shadow-sm" style="top: 2px">{{ process.pid }}</p>
        <button @click="killProcess" class="btn btn-sm btn-primary" :disabled="!process.running">Остановить</button>
        <button @click="clearProcess" class="btn btn-sm btn-primary">Скрыть</button>
        <button @click="deleteProcess" class="btn btn-sm btn-danger" :disabled="!!process.running">Удалить</button>
      </div>
      <pre class="text-light bg-dark p-2">
{{ process.log }}
</pre>
    </div>
  </f-loader>

</template>

<script>
import PageHeader from "@/components/PageHeader";
import FlInput from "@/pages/flow/forms/components/FlInput";
import FLoader from "@/components/FLoader";
import {http} from "@/misc/http";
import SimpleTable from "@/components/simple-table/SimpleTable";
import {config} from "@/state/config";

export default {
  components: {SimpleTable, FLoader, FlInput, PageHeader},
  data() {
    return {
      chatServer: "",
      nMessages: 10,
      nConnections: 100,
      nProcesses: 1,
      status: [],
      selectedPid: null,
      process: null,
    }
  },

  async mounted() {
    const chatServerHost = config.chatServer.chatServerHost || window.location.hostname;
    const chatServerPort = config.chatServer.chatServerPort || "80";
    const chatServerProto =config.chatServer.chatServerProto || "ws";
    this.chatServer = chatServerProto + "://" + chatServerHost + ":" + chatServerPort + "/ws/chat/bar";

    await this.update();

    this.i = setInterval(this.update, 2000);
  },

  beforeUnmount() {
    clearInterval(this.i);
  },

  methods: {
    async update() {
      await this.$refs.loader2.wrap(async () => {
        await this.updateStatus();
        await this.updateProcess();
      }, true);
    },

    async updateStatus() {
      this.status = await http.get("/loadtest/status");
    },

    async updateProcess() {
      if (this.selectedPid) {
        const process = await http.get("/loadtest/process/" + this.selectedPid);
        if (process.pid == this.selectedPid)
          this.process = process;
      }
    },

    clearProcess() {
      this.selectedPid = null;
      this.process = null;
    },

    async onClickProcess(process) {
      await this.$refs.loader.wrap(async () => {
        this.selectedPid = process.pid;
        await this.updateProcess();
      }, true);
    },

    async onStart() {
      await this.$refs.loader.wrap(async () => {
        await http.post("/loadtest/start", {
          chat_server: this.chatServer,
          n_messages: this.nMessages,
          n_connections: this.nConnections,
          n_processes: this.nProcesses,
        });
        await this.updateStatus();
      });
    },

    async killProcess() {
      await this.$refs.loader.wrap(async () => {
        await http.post("/loadtest/process/" + this.process.pid + "/kill");
        await this.updateProcess();
        await this.updateStatus();
      }, true);
    },

    async deleteProcess() {
      await this.$refs.loader.wrap(async () => {
        const pid = this.process.pid;
        this.clearProcess();
        await http.delete("/loadtest/process/" + pid);
        await this.updateStatus();
      }, true);
    },


  },
}
</script>

